import { memo } from "react";

const DocumentEmptyState = () => {
  return (
    <svg width="131.99980104377366" height="110.85800170898438" xmlns="http://www.w3.org/2000/svg" fill="none">
      <g>
        <path
          id="svg_1"
          fillOpacity="0.13"
          fill="#B8AEE9"
          d="m65.99991,110.858c30.2577,0 54.7864,-24.6305 54.7864,-55.0139c0,-30.3834 -24.5287,-55.01402 -54.7864,-55.01402c-30.2577,0 -54.78641,24.63062 -54.78641,55.01402c0,30.3834 24.52871,55.0139 54.78641,55.0139z"
        />
        <rect
          id="svg_2"
          strokeWidth="0.64078"
          stroke="#EBEBEB"
          fill="white"
          rx="2.24272"
          height="35.2427"
          width="131.359"
          y="15.88089"
          x="0.32042"
        />
        <rect
          id="svg_3"
          fillOpacity="0.13"
          fill="#9B8DDF"
          rx="2.24272"
          height="4.48544"
          width="64.0777"
          y="35.42187"
          x="36.5243"
        />
        <rect id="svg_4" fill="#C5BDEB" rx="2.24272" height="4.48544" width="23.7087" y="27.09177" x="36.5243" />
        <g id="svg_5" opacity="0.3">
          <path
            id="svg_6"
            fill="#141516"
            d="m23.0358,26.69547c-0.5255,-0.0003 -1.0295,-0.2092 -1.4011,-0.5808c-0.3716,-0.3716 -0.5805,-0.87554 -0.5807,-1.40108l0,-2.75074l-8.8559,0c-0.3397,-0.00001 -0.6761,0.06692 -0.99,0.19696c-0.3138,0.13004 -0.599,0.32064 -0.8392,0.56091c-0.2402,0.24027 -0.43064,0.52551 -0.56056,0.83941c-0.12992,0.31391 -0.19674,0.65034 -0.19661,0.99008l0,15.59046c-0.00013,0.3397 0.06669,0.6761 0.19661,0.9901c0.12992,0.3139 0.32036,0.5991 0.56056,0.8394c0.2402,0.2402 0.5254,0.4308 0.8392,0.5609c0.3139,0.13 0.6503,0.197 0.99,0.197l10.6301,0c0.3397,0 0.6761,-0.067 0.99,-0.197c0.3138,-0.1301 0.599,-0.3207 0.8392,-0.5609c0.2402,-0.2403 0.4307,-0.5255 0.5606,-0.8394c0.1299,-0.314 0.1967,-0.6504 0.1966,-0.9901l0,-13.4443l-2.3788,-0.0009z"
            opacity="0.3"
          />
        </g>
        <path
          id="svg_7"
          fill="#141516"
          d="m25.4143,26.69547l-2.3788,0c-0.5255,-0.0003 -1.0294,-0.2092 -1.4011,-0.5808c-0.3716,-0.3716 -0.5805,-0.87554 -0.5807,-1.40108l0,-2.75074l4.3606,4.73262z"
        />
        <path
          id="svg_8"
          fill="#141516"
          d="m27.2917,38.36127l-12.018,0c-0.8525,0 -1.5436,0.6911 -1.5436,1.5436l0,3.5831c0,0.8525 0.6911,1.5435 1.5436,1.5435l12.018,0c0.8524,0 1.5435,-0.691 1.5435,-1.5435l0,-3.5831c0,-0.8525 -0.6911,-1.5436 -1.5435,-1.5436z"
        />
        <rect
          id="svg_16"
          strokeWidth="0.64078"
          stroke="#EBEBEB"
          fill="white"
          rx="2.24272"
          height="35.2427"
          width="131.359"
          y="58.45511"
          x="0.32042"
        />
        <rect
          id="svg_17"
          fillOpacity="0.13"
          fill="#9B8DDF"
          rx="2.24272"
          height="4.48544"
          width="43.5728"
          y="77.99607"
          x="36.5244"
        />
        <rect id="svg_18" fill="#C5BDEB" rx="2.24272" height="4.48544" width="29.4757" y="69.66797" x="36.5244" />
        <g id="svg_19" opacity="0.3">
          <path
            id="svg_20"
            fill="#141516"
            d="m22.6028,70.59815c-0.5085,-0.0005 -0.996,-0.2095 -1.3556,-0.581c-0.3596,-0.3715 -0.5618,-0.8753 -0.5623,-1.4007l0,-2.75151l-8.5702,0c-0.6638,0 -1.3005,0.27249 -1.7699,0.75749c-0.46937,0.48501 -0.73308,1.14281 -0.73308,1.82872l0,15.5903c0.00099,0.6852 0.26513,1.3421 0.73438,1.8262c0.4693,0.4842 1.1054,0.7562 1.7686,0.7562l10.2881,0c0.6632,0 1.2993,-0.272 1.7686,-0.7562c0.4693,-0.4841 0.7334,-1.141 0.7344,-1.8262l0,-13.4433l-2.303,0z"
            opacity="0.3"
          />
        </g>
        <path
          id="svg_21"
          fill="#141516"
          d="m24.9054,70.59815l-2.303,0c-0.5085,-0.0005 -0.9961,-0.2095 -1.3556,-0.581c-0.3596,-0.3715 -0.5618,-0.8753 -0.5623,-1.40071l0,-2.7515l4.2209,4.73321z"
        />
        <path
          id="svg_22"
          fill="#141516"
          d="m21.7592,37.03617l-9.6026,0c-0.0925,0 -0.1812,-0.038 -0.2466,-0.1055c-0.0655,-0.0676 -0.1022,-0.1593 -0.1022,-0.2549c0.0002,-0.0954 0.0371,-0.1868 0.1025,-0.2542c0.0654,-0.0674 0.154,-0.1052 0.2463,-0.1052l9.6026,0c0.0923,0 0.1808,0.0378 0.246,0.1052c0.0653,0.0675 0.1019,0.1589 0.1019,0.2542c0.0001,0.0473 -0.0088,0.0942 -0.0262,0.1379c-0.0174,0.0437 -0.043,0.0834 -0.0753,0.1169c-0.0324,0.0335 -0.0708,0.06 -0.113,0.0782c-0.0423,0.0181 -0.0876,0.0274 -0.1334,0.0274z"
        />
        <path
          id="svg_23"
          fill="#141516"
          d="m21.7592,32.97567l-9.6026,0c-0.0923,0 -0.1809,-0.0379 -0.2463,-0.1053c-0.0654,-0.0673 -0.1023,-0.1587 -0.1025,-0.2542c0,-0.0955 0.0367,-0.1872 0.1022,-0.2548c0.0654,-0.0676 0.1541,-0.1056 0.2466,-0.1056l9.6026,0c0.0458,0 0.0911,0.0094 0.1334,0.0275c0.0422,0.0181 0.0806,0.0447 0.113,0.0782c0.0323,0.0334 0.0579,0.0732 0.0753,0.1169c0.0174,0.0437 0.0263,0.0906 0.0262,0.1378c0,0.0954 -0.0366,0.1868 -0.1019,0.2542c-0.0652,0.0674 -0.1537,0.1053 -0.246,0.1053z"
        />
        <path
          id="svg_24"
          fill="#141516"
          d="m21.7592,35.00687l-9.6026,0c-0.0925,0 -0.1812,-0.0379 -0.2466,-0.1055c-0.0655,-0.0676 -0.1022,-0.1593 -0.1022,-0.2549c0.0002,-0.0954 0.0371,-0.1868 0.1025,-0.2542c0.0654,-0.0674 0.154,-0.1052 0.2463,-0.1052l9.6026,0c0.0923,0 0.1808,0.0379 0.246,0.1053c0.0653,0.0674 0.1019,0.1588 0.1019,0.2541c0.0001,0.0473 -0.0088,0.0942 -0.0262,0.1379c-0.0174,0.0437 -0.043,0.0834 -0.0753,0.1169c-0.0324,0.0335 -0.0708,0.0601 -0.113,0.0782c-0.0423,0.0181 -0.0876,0.0274 -0.1334,0.0274z"
        />
        <path
          id="svg_25"
          fill="#141516"
          d="m17.9718,30.94247l-5.8152,0c-0.0923,0 -0.1809,-0.0379 -0.2463,-0.1052c-0.0654,-0.0674 -0.1023,-0.1588 -0.1025,-0.2543c0,-0.0955 0.0367,-0.1872 0.1022,-0.2548c0.0654,-0.0676 0.1541,-0.1056 0.2466,-0.1056l5.8152,0c0.0923,0.0003 0.1808,0.0384 0.246,0.1059c0.0652,0.0676 0.1018,0.1591 0.1018,0.2545c-0.0002,0.0953 -0.0369,0.1866 -0.1021,0.2539c-0.0652,0.0674 -0.1536,0.1053 -0.2457,0.1056z"
        />
        <path
          id="svg_26"
          fill="#141516"
          d="m17.9718,28.91707l-5.8152,0c-0.0923,0 -0.1809,-0.0379 -0.2463,-0.1053c-0.0654,-0.0673 -0.1023,-0.1587 -0.1025,-0.2542c0,-0.0955 0.0367,-0.1872 0.1022,-0.2548c0.0654,-0.0676 0.1541,-0.1055 0.2466,-0.1055l5.8152,0c0.0923,0.0002 0.1808,0.0383 0.246,0.1058c0.0652,0.0676 0.1018,0.1591 0.1018,0.2545c-0.0002,0.0953 -0.0369,0.1866 -0.1021,0.2539c-0.0652,0.0674 -0.1536,0.1053 -0.2457,0.1056z"
        />
        <path
          id="svg_27"
          fill="#141516"
          d="m26.7215,82.26535l-11.6303,0c-0.825,0 -1.4938,0.691 -1.4938,1.5434l0,3.5829c0,0.8524 0.6688,1.5434 1.4938,1.5434l11.6303,0c0.825,0 1.4938,-0.691 1.4938,-1.5434l0,-3.5829c0,-0.8524 -0.6688,-1.5434 -1.4938,-1.5434z"
        />
        <path id="svg_28" fill="white" d="m17.4124,42.55171l0,0.6987l-0.6994,0l0,-0.6987l0.6994,0z" />
        <path
          id="svg_29"
          fill="white"
          d="m18.4407,42.23241l0,1.0139l-0.6762,0l0,-2.8899l1.0957,0c0.3321,0 0.586,0.0855 0.7599,0.2556c0.088,0.0894 0.1568,0.197 0.2016,0.3158c0.0449,0.1187 0.065,0.246 0.0589,0.3733c0.0034,0.168 -0.0368,0.3339 -0.1163,0.4805c-0.0812,0.1434 -0.2016,0.2587 -0.346,0.3316c-0.1742,0.0851 -0.3655,0.1263 -0.5581,0.1202l-0.4195,-0.001zm0.7516,-0.9313c0,-0.2563 -0.1358,-0.3844 -0.4074,-0.3844l-0.3442,0l0,0.7525l0.3442,0c0.2716,0.0026 0.4074,-0.1201 0.4074,-0.3681z"
        />
        <path
          id="svg_30"
          fill="white"
          d="m22.5525,42.54621c-0.1165,0.2185 -0.2924,0.3969 -0.506,0.5132c-0.2404,0.1271 -0.5077,0.1902 -0.7776,0.1835l-1.0557,0l0,-2.8899l1.0557,0c0.2701,-0.007 0.5378,0.0547 0.7794,0.1797c0.2131,0.1138 0.3885,0.2904 0.5042,0.5075c0.121,0.2304 0.1819,0.4894 0.1767,0.7515c0.005,0.2631 -0.0558,0.5229 -0.1767,0.7545zm-0.7274,-0.1452c0.0756,-0.0802 0.1342,-0.1758 0.172,-0.2807c0.0378,-0.1049 0.054,-0.2168 0.0475,-0.3286c0.0065,-0.1116 -0.0096,-0.2234 -0.0475,-0.3281c-0.0378,-0.1048 -0.0964,-0.2003 -0.172,-0.2802c-0.1692,-0.1534 -0.3902,-0.2315 -0.6148,-0.2172l-0.3209,0l0,1.6511l0.3209,0c0.2245,0.0141 0.4453,-0.0636 0.6148,-0.2163z"
        />
        <path
          id="svg_31"
          fill="white"
          d="m24.9363,40.35641l0,0.5565l-1.1468,0l0,0.6333l0.8855,0l0,0.5314l-0.8855,0l0,1.1687l-0.6772,0l0,-2.8899l1.824,0z"
        />
        <path
          id="svg_32"
          fill="#141516"
          d="m21.5903,28.19727l-1.6444,0c-0.2867,0 -0.5191,0.24 -0.5191,0.5362l0,1.6992c0,0.2961 0.2324,0.5362 0.5191,0.5362l1.6444,0c0.2867,0 0.519,-0.2401 0.519,-0.5362l0,-1.6992c0,-0.2962 -0.2323,-0.5362 -0.519,-0.5362z"
        />
        <path
          id="svg_13"
          fill="#141516"
          d="m19.6369,79.33131l-4.2453,0c-0.4156,-0.00048 -0.8141,-0.16032 -1.1079,-0.44451c-0.2939,-0.28419 -0.4592,-0.66942 -0.4597,-1.07129l0,-4.10501c0.0005,-0.40187 0.1658,-0.7871 0.4597,-1.07129c0.2938,-0.28419 0.6923,-0.44402 1.1079,-0.44451l4.2453,0c0.4155,0.00048 0.8138,0.16042 1.1075,0.44451c0.2937,0.28419 0.4589,0.66952 0.4591,1.07129l0,4.10501c-0.0002,0.40177 -0.1654,0.787 -0.4591,1.07119c-0.2937,0.28419 -0.692,0.44412 -1.1075,0.4446zm-4.2453,-6.4665c-0.2319,0.00019 -0.4542,0.08935 -0.6182,0.24793c-0.164,0.15858 -0.2562,0.37353 -0.2565,0.59777l0,4.10501c0.0003,0.22424 0.0925,0.43919 0.2565,0.59777c0.164,0.15848 0.3863,0.24773 0.6182,0.24793l4.2453,0c0.2318,-0.00019 0.454,-0.08944 0.6178,-0.24802c0.1638,-0.15858 0.2558,-0.37353 0.2558,-0.59767l0,-4.10501c0,-0.22414 -0.092,-0.43909 -0.2558,-0.59767c-0.1638,-0.15858 -0.386,-0.24783 -0.6178,-0.24802l-4.2453,0z"
        />
        <path
          id="svg_14"
          fill="#141516"
          d="m20.8567,76.72798l0,0.8073c-0.0002,0.3237 -0.1289,0.634 -0.3578,0.8629c-0.2288,0.2288 -0.5392,0.3575 -0.8628,0.3578l-4.2453,0c-0.3237,0 -0.6342,-0.1287 -0.8631,-0.3576c-0.2289,-0.2289 -0.3575,-0.5393 -0.3575,-0.8631l0,-1.3552c0.6795,-0.1461 1.7146,-0.1922 2.9708,0.3095l0.7785,-0.742l0.5305,1.3456c0,0 0.1423,-0.495 0.6017,-0.4248c0.4594,0.0701 1.2034,0.3191 1.5215,0.1067c0.0857,-0.0495 0.1864,-0.0662 0.2835,-0.0471z"
        />
        <path
          id="svg_15"
          fill="#141516"
          d="m19.3695,74.89126c0.2606,0 0.4719,-0.2113 0.4719,-0.4719c0,-0.2606 -0.2113,-0.4719 -0.4719,-0.4719c-0.2606,0 -0.4719,0.2113 -0.4719,0.4719c0,0.2606 0.2113,0.4719 0.4719,0.4719z"
        />
        <path id="svg_9" fill="white" d="m17.15158,86.5203l0,0.6997l-0.7237,0l0,-0.6997l0.7237,0z" />
        <path
          id="svg_10"
          fill="white"
          d="m19.30048,84.17026l0,1.9742c0,0.3031 -0.0823,0.536 -0.247,0.6987c-0.0919,0.0848 -0.2,0.1502 -0.3177,0.1923c-0.1177,0.0421 -0.2428,0.0601 -0.3676,0.0528c-0.1367,0.0074 -0.2735,-0.0125 -0.4025,-0.0583c-0.129,-0.0459 -0.2477,-0.1169 -0.3491,-0.2089c-0.1852,-0.1787 -0.2781,-0.435 -0.2787,-0.7689l0.691,0c0,0.2701 0.1029,0.4047 0.3066,0.4047c0.1778,0 0.2663,-0.1038 0.2663,-0.3105l0,-1.9741l0.6987,-0.002z"
        />
        <path
          id="svg_11"
          fill="white"
          d="m20.42497,86.06116l0,1.014l-0.6988,0l0,-2.8902l1.1322,0c0.3428,0 0.6042,0.0849 0.7843,0.2547c0.0911,0.0893 0.1623,0.1969 0.2088,0.3157c0.0466,0.1188 0.0675,0.246 0.0613,0.3735c0.0026,0.1679 -0.0388,0.3336 -0.1202,0.4805c-0.0837,0.1433 -0.2081,0.2584 -0.3575,0.3307c-0.1799,0.0854 -0.3776,0.1269 -0.5767,0.1211l-0.4334,0zm0.7765,-0.9323c0,-0.2563 -0.1403,-0.3845 -0.4209,-0.3845l-0.3556,0l0,0.7526l0.3556,0c0.2806,0.0025 0.4209,-0.1202 0.4209,-0.3681z"
        />
        <path
          id="svg_12"
          fill="white"
          d="m24.53958,84.42278c0.2327,0.175 0.3892,0.4328 0.4373,0.7199l-0.7401,0c-0.0501,-0.1006 -0.1291,-0.1839 -0.2268,-0.2393c-0.1101,-0.0654 -0.2363,-0.0987 -0.3643,-0.0961c-0.0994,-0.0041 -0.1984,0.0138 -0.2901,0.0524c-0.0917,0.0385 -0.1738,0.0967 -0.2404,0.1706c-0.141,0.1681 -0.2128,0.3835 -0.2009,0.6026c0,0.2749 0.0702,0.486 0.2105,0.6334c0.0789,0.0765 0.1729,0.1357 0.276,0.1738c0.1031,0.038 0.2131,0.0541 0.3228,0.0472c0.1568,0.0029 0.3103,-0.0453 0.4373,-0.1374c0.1296,-0.0968 0.2233,-0.2342 0.2662,-0.3902l-0.8833,0l0,-0.5027l1.4677,0l0,0.6911c-0.0561,0.172 -0.1449,0.3316 -0.2615,0.47c-0.1262,0.1491 -0.2833,0.2691 -0.4603,0.3517c-0.2002,0.0925 -0.4187,0.1385 -0.6392,0.1346c-0.2682,0.007 -0.5334,-0.057 -0.7689,-0.1855c-0.2154,-0.1212 -0.3908,-0.3025 -0.5046,-0.5219c-0.1223,-0.2375 -0.1834,-0.5018 -0.1778,-0.7689c-0.0048,-0.2655 0.0563,-0.528 0.1778,-0.7641c0.1136,-0.2189 0.2882,-0.4001 0.5027,-0.5219c0.232,-0.1275 0.4936,-0.1915 0.7583,-0.1855c0.3218,-0.014 0.639,0.0797 0.9016,0.2662z"
        />
      </g>
    </svg>
  );
};

export default memo(DocumentEmptyState);
